var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 11.9307,
    cy: 11.9307,
    r: 11.9307,
    transform: "rotate(180 11.9307 11.9307)",
    fill: "#0070FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 11.9299,
    cy: 11.9299,
    r: 8.6814,
    transform: "rotate(180 11.9299 11.9299)",
    fill: "#0070FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9285,
    cy: 11.9305,
    r: 7.23361,
    transform: "rotate(180 11.9285 11.9305)",
    fill: "#0070FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarine);
export default __webpack_public_path__ + "static/media/Marine.d96292f52f89f395dec0e354ba18aa34.svg";
export { ForwardRef as ReactComponent };